import { defineMessages } from 'react-intl';

type MessageKeys = 'defaultScenarioTag' | 'inactiveScenarioTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		defaultScenarioTag: {
			id: 'ai-mate.browse-agents.scenario-pill.default-scenario-tag',
			defaultMessage: 'Default',
			description:
				'Tag label shown on a scenario pill to indicate it is the default scenario for an agent',
		},
		inactiveScenarioTooltip: {
			id: 'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip',
			defaultMessage: 'Inactive',
			description:
				'Tooltip shown on a scenario pill to indicate the scenario is currently inactive',
		},
	});

export default message;
